import * as Icons from "@phosphor-icons/react";
import { checkIsBusinessUser } from "selectors/user";
import { checkSelectedBusinessRpaMode, getSelectedBusinessData } from "selectors/businesses";
import { getDocumentsStats } from "selectors/documents";
import { useSelector } from "react-redux";
import DataStatuses from "const/DataStatuses";
import DocumentsStatuses from "nlib/pages/DocumentsPage/DocumentsStatuses";
import IntegrationServices from "const/IntegrationServices";
import React, { useMemo } from "react";
import StatusFilter from "nlib/common/StatusFilter";

const ICONS = {
  [DataStatuses.TO_RECONCILE]: Icons.Question,
  [DataStatuses.NEED_REACTION]: Icons.WarningCircle,
  [DataStatuses.TO_REVIEW]: Icons.Eye,
  [DataStatuses.TO_REPORT]: Icons.CheckCircle,
  [DataStatuses.EXPORTED]: Icons.ArrowSquareOut,
  [DataStatuses.EXCLUDED]: Icons.MinusCircle,
  [DataStatuses.TO_EXTRACT]: Icons.Cloud,
  [null]: Icons.ListDashes
};

const getIcon = (value) => ICONS[value];

const DocumentsStatusFilter = (props) => {
  const rpaMode = useSelector(checkSelectedBusinessRpaMode);

  const documentsStats = useSelector(getDocumentsStats);

  const selectedBusinessData = useSelector(getSelectedBusinessData);

  const businessUser = useSelector(checkIsBusinessUser);

  const { extraData: { integrationService } = {} } = selectedBusinessData;

  const statusesList = useMemo(() => {
    const statusesData = businessUser
      ? DocumentsStatuses.getBusinessUserStatusData()
      : DocumentsStatuses.getStatusData(undefined, rpaMode);

    return Object.values(statusesData).map((statusData) => {
      if (statusData.value === DataStatuses.EXPORTED) {
        const { logo: serviceLogo } = IntegrationServices.getByValue(integrationService) || {};

        return [
          {
            value: "unpaid",
            iconComponent: ({ className }) => <img src={serviceLogo} className={className} />,
            labelLangId: "unpaid",
            descriptionMessageId: "unpaidDocumentsDescription",
            getCount: () => documentsStats.exportedUnpaid
          },
          {
            value: "paid",
            paid: true,
            iconComponent: ({ className }) => <img src={serviceLogo} className={className} />,
            labelLangId: "paid",
            descriptionMessageId: "paidDocumentsDescription",
            getCount: () => documentsStats.exportedPaid
          }
        ];
      }

      return statusData;
    }).flat().filter(Boolean);
  }, [businessUser, integrationService, rpaMode, documentsStats]);

  return (
    <StatusFilter
      {...props}
      statusesList={statusesList}
      stats={documentsStats}
      getIcon={getIcon} />
  );
};

export default React.memo(DocumentsStatusFilter);
